"use strict";

// module Partial

exports.crashWith = function () {
  return function (msg) {
    throw new Error(msg);
  };
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-partial/src/Partial.js
// module id = 76
// module chunks = 0